import { isSSR } from "./default";

export const jsLoader = (url: string) => {
  if (isSSR()) return;

  const script = document.createElement("script");
  script.setAttribute("src", url);
  script.setAttribute("type", "text/javascript");
  document.body.appendChild(script);
  return;
};

export const cssLoader = (url: string) => {
  if (isSSR()) return;
  const link = document.createElement("link");
  link.setAttribute("rel", "stylesheet");
  link.setAttribute("href", url);
  document.head.appendChild(link);
  return;
};

export const cssStyleLoader = (css: string) => {
  if (isSSR()) return;

  const style = document.createElement("style");
  style.innerHTML = css;
  document.head.appendChild(style);
  return;
};

export const jsScriptLoader = (js: string) => {
  if (isSSR()) return;
  const script = document.createElement("script");
  script.innerHTML = js;
  document.body.appendChild(script);
  return;
};
